// extracted by mini-css-extract-plugin
export default {"title":"error_title_u5RIn"};